import { NgModule, PLATFORM_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountDownTimerComponent } from './components/countdown-timer/countdown-timer.component';
import { NgbModule, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { ValidationMessageDirective } from './directives/validation-message.directive';
import { CurrencyInputDirective } from './directives/currency-input.directive';
import { GroupByPipe } from './pipes/group-by.pipe';
import { IfEmptyPipe } from './pipes/if-empty.pipe';
import { ReplacePipe } from './pipes/replace.pipe';
import { DateInputDirective } from './directives/date-input.directive';
import { MileStoneComponent } from './components/mile-stone/mile-stone.component';
import { CardComponent } from './components/card/card.component';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { UnmatchedRequestComponent } from './components/unmatched-request/unmatched-request.component';
import { FilterComponent } from './components/filter/filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhoneInputDirective } from './directives/phone-input-directive';
import { RouterModule } from '@angular/router';
import { UiSwitchModule } from 'ngx-toggle-switch';
import { LoaderComponent } from './components/loader/loader.component';
import { LoaderService } from './components/loader/loader.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { createTranslateLoader } from '../core/translation/loader-factory';
import { HttpClient } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonApi } from '../core/http/common.api.service';
import { FindByPipe } from './pipes/find-by.pipe';
import { ProcessPaymentRequestComponent } from './components/process-payment-request/process-payment-request.component';
import { SummaryOfLiveDealComponent } from './components/summary-of-live-deal/summary-of-live-deal.component';
import { Ng5SliderModule } from 'ng5-slider';
import { FileInputAccessorModule } from 'file-input-accessor';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SummaryOfRefundComponent } from './components/summary-of-refund/summary-of-refund.component';
import { ScrollAgreementDirective } from './directives/scroll-agreement.directive';
import { ProcessPaymentBankRequestComponent } from './components/process-payment-bank-request/process-payment-bank-request.component';
import { ProcessCreditBalancePaymentComponent } from './components/process-credit-balance-payment/process-credit-balance-payment.component';
import { PaymentNoteComponent } from './components/payment-note/payment-note.component';
import { VideoToturialsComponent } from './components/video-toturials/video-toturials.component';
import { RewardSummaryComponent } from './components/reward-summary/reward-summary.component';
import { DragDropDirective } from './directives/drag-and-drop-file.directive';
import { BillLadingTypeSupplierPipe } from './pipes/billLadingTypeSupplier.pipe';
import { BillLadingTypeEnumLangPipe } from './pipes/billLadingTypeEnumLang.pipe';
import { PortInputComponent } from './components/port/port-input.component';
import { ExpectedDepartureDateInputComponent } from './components/expected-depature-date/expected-depature-date-input.component';
import { ExpectedArrivalDateInputComponent } from './components/expected-arrival-date/expected-arrival-date-input.component';
import { ContainerTypeInputComponent } from './components/container-type/container-type-input.component';
import { ContainerSizeInputComponent } from './components/container-size/container-size-input.component';
import { BillLadingTypeInputComponent } from './components/bill-lading-type/bill-lading-type-input.component';
import { RoutePreferenceInputComponent } from './components/route-preference/route-preference-input.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { FreightPostStatusPipe } from './pipes/freight-post-status-pipe';
import { BuyerFreightPostCardComponent } from './components/buyer-freight-post-card/buyer-freight-post-card.component';
import { OrganizationTypeEnumLangPipe } from './pipes/organization-type-enum-lang-convert.pipe';


@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    RouterModule,
    UiSwitchModule,
    RouterModule,
    NgSelectModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient, PLATFORM_ID]
      }
    }),
    Ng5SliderModule,
    FileInputAccessorModule,
    InfiniteScrollModule,
  ],
  declarations: [
    CardComponent,
    CountDownTimerComponent,
    FilterComponent,
    StatisticsComponent,
    UnmatchedRequestComponent,
    ValidationMessageDirective,
    CurrencyInputDirective,
    DragDropDirective,
    DateInputDirective,
    PhoneInputDirective,

    GroupByPipe,
    IfEmptyPipe,
    ReplacePipe,
    BillLadingTypeSupplierPipe,
    BillLadingTypeEnumLangPipe,
    OrganizationTypeEnumLangPipe,
    FreightPostStatusPipe,

    MileStoneComponent,
    LoaderComponent,
    FindByPipe,
    ProcessPaymentRequestComponent,
    SummaryOfLiveDealComponent,
    SummaryOfRefundComponent,
    ScrollAgreementDirective,
    ProcessPaymentBankRequestComponent,
    ProcessCreditBalancePaymentComponent,
    PaymentNoteComponent,
	  VideoToturialsComponent,
    RewardSummaryComponent,
    PaginationComponent,

    PortInputComponent,
    ExpectedDepartureDateInputComponent,
    ExpectedArrivalDateInputComponent,
    ContainerTypeInputComponent,
    ContainerSizeInputComponent,
    BillLadingTypeInputComponent,
    RoutePreferenceInputComponent,
    BuyerFreightPostCardComponent
  ],
  exports: [
    NgbModule,
    NgSelectModule,
    UiSwitchModule,
    CardComponent,
    BuyerFreightPostCardComponent,
    FilterComponent,
    StatisticsComponent,
    UnmatchedRequestComponent,
    CountDownTimerComponent,
    ValidationMessageDirective,
    CurrencyInputDirective,
    DateInputDirective,
    PhoneInputDirective,
    DragDropDirective,
    NgbDatepicker,

    GroupByPipe,
    IfEmptyPipe,
    ReplacePipe,
    BillLadingTypeSupplierPipe,
    BillLadingTypeEnumLangPipe,
    OrganizationTypeEnumLangPipe,
    FreightPostStatusPipe,

    MileStoneComponent,
    LoaderComponent,
    FindByPipe,
    ProcessPaymentRequestComponent,
    ProcessCreditBalancePaymentComponent,
    SummaryOfLiveDealComponent,
    SummaryOfRefundComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ScrollAgreementDirective,
    ProcessPaymentBankRequestComponent,
    PaymentNoteComponent,
	  VideoToturialsComponent,
    RewardSummaryComponent,
    PaginationComponent,

    PortInputComponent,
    ExpectedDepartureDateInputComponent,
    ExpectedArrivalDateInputComponent,
    ContainerTypeInputComponent,
    ContainerSizeInputComponent,
    BillLadingTypeInputComponent,
    RoutePreferenceInputComponent
  ],
  providers: [
    GroupByPipe,
    IfEmptyPipe,
    ReplacePipe,
    FindByPipe,
    MileStoneComponent,
    NgbDatepicker,
    CommonApi
  ]
})
export class SharedModule { }
